import { useState } from 'react';
import { contactData } from '@/mocks/home';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value || '';
    if (honeypot.trim()) {
      setSubmitted(true);
      setFormError('');
      return;
    }
    setSubmitted(true);
    setFormError('');
    form.reset();
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">{contactData.title} · {contactData.description}</p>

        <div className="max-w-[700px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Contact Info */}
            <div className="space-y-4">
              <div className="flex items-start gap-3 p-4 bg-background-100 rounded-lg">
                <span className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                  <i className="ri-mail-line text-primary-600"></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-900 mb-1">投稿邮箱</p>
                  <p className="text-sm text-foreground-600">{contactData.email}</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background-100 rounded-lg">
                <span className="w-9 h-9 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-accent-600"></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-900 mb-1">回复时效</p>
                  <p className="text-sm text-foreground-600">{contactData.response}</p>
                </div>
              </div>
            </div>

            {/* Form */}
            {submitted ? (
              <div className="flex flex-col items-center justify-center p-8 bg-background-100 rounded-lg text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-full mb-3">
                  <i className="ri-check-line text-primary-600 text-xl"></i>
                </div>
                <p className="text-sm font-bold text-foreground-900 mb-1">提交成功</p>
                <p className="text-xs text-foreground-500">我们已收到您的信息，将在{contactData.response}内回复。</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                {formError && (
                  <p className="text-xs text-primary-600 bg-primary-50 p-2 rounded">{formError}</p>
                )}
                {/* Honeypot */}
                <input
                  type="text"
                  name="phone_alt"
                  className="website-alt-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <input
                  type="text"
                  name="name"
                  placeholder="您的昵称"
                  required
                  className="w-full px-3 py-2 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="联系邮箱"
                  required
                  className="w-full px-3 py-2 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <textarea
                  name="message"
                  placeholder="请描述您要投稿的内容或线索..."
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 py-2 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                ></textarea>
                <button
                  type="submit"
                  className="w-full px-4 py-2.5 bg-primary-500 text-background-50 font-bold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  提交投稿
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}